/* eslint-disable @typescript-eslint/naming-convention */
const testEnv = {
  apiUrl: 'https://api-merchantconnect.dulux.co.uk',
  azureConnectionString: 'BlobEndpoint=https://duluxhnc.blob.core.windows.net/;QueueEndpoint=https://hncdev.queue.core.windows.net/;FileEndpoint=https://hncdev.file.core.windows.net/;TableEndpoint=https://hncdev.table.core.windows.net/;SharedAccessSignature=sp=racw&st=2026-02-24T13:15:42Z&se=2028-02-24T21:30:42Z&spr=https&sv=2024-11-04&sr=c&sig=WnYDaO%2BA2qtKJzb3iJFE4VF8pJW75UmDFMbmVIQyl4M%3D',
  containerName: 'merchantconnect-prod',
  docRepoContainerName: 'merchantconnect-doc-repo-prod',
  assetFolder: 'brand_assets_images',
  merchantFolder: 'logos',
  articleFolder: 'articles',
  productFolder: 'npd_images',
  digitalToolkitFolder: 'digitaltoolkit',
  industryEventsFolder: 'industryevents',
  insightFolder: 'industry_insight',
  newsletterFolder: 'newsletter',
  industryCloudUrl: 'https://ic.hnccloud.com/',
  gaToken: 'G-5MVSK7JYZ9',
  gaAdminToken: 'G-PQJBTZQ1TD',
  heritageToolkitId: '04e011d0-d987-4805-a26c-1440519e411c'
};

type EnvironmentVariables = typeof testEnv;

const liveEnv = (window as any).__env__ as EnvironmentVariables;

export const environment = liveEnv || testEnv;
